import { canManageScoring } from "../utils/auth";

// Tooltip shown on a disabled scoring management control (create/edit/delete).
export const MANAGE_SCORING_DISABLED_MESSAGE =
  "Your access is read-only, so you can't create, edit or delete scoring profiles.";

/**
 * Whether the current user may create/edit/delete scoring profiles.
 *
 * Read-only users cannot; everyone else can. On RBAC v2 that is deliberately NOT
 * an Org Admin check: the admin app lets any non-readOnly user edit the same
 * models (`useUserRole.canEditScoring`), so gating on orgAdmin here only hid a
 * button for people the API would have accepted.
 */
export const useCanManageScoring = (): boolean => canManageScoring();
